import { render, staticRenderFns } from "./SkillTags.vue?vue&type=template&id=4d6edb1e&"
import script from "./SkillTags.vue?vue&type=script&lang=ts&"
export * from "./SkillTags.vue?vue&type=script&lang=ts&"
import style0 from "./SkillTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports